import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from 'src/utils/api';

export const searchPoReceivingDetailsByPoNumberAndDate: any = createAsyncThunk(
  'receiveHours/searchPoReceivingDetailsByPoNumberAndDate',
  async ({ purchaseOrder, endDate }: any, { rejectWithValue }) => {
    try {
      const response = await client.get(
        `PO/receive/${purchaseOrder}/${endDate}`,
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
export const poReceiveApproveByITLeader: any = createAsyncThunk(
  'receiveHours/poReceiveApproveByITLeader',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await client.post(`PO/receive`, payload);

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
